import React, { PureComponent } from 'react';
import GridButtonLayout from '../../../../components/GridButtonLayout/GridButtonLayout';

class FreeToolsView extends PureComponent {
  componentDidMount() {
    this.props.renderHeaderButton(false);
  }
  render() {
    const { intl, history } = this.props;
    return (
      <div className="free-tools-view">
        <div id="wrapper">
          <div id="page-content-wrapper">
            <div className="container-fluid policyInsuranceType">
              <div className="row">
                <div className="col-lg-12">
                  <GridButtonLayout
                    items={[
                      {
                        image: <img src="img/icons/dice_active_color.svg" alt="" />,
                        text: intl.formatMessage({ id: 'Lucky Game' }),
                        onClick: () => history.push('/dice')
                      },
                      {
                        image: <img src="img/icons/calculator_active_color.svg" alt="" />,
                        text: intl.formatMessage({ id: 'Target Calculator' }),
                        onClick: () => history.push('/targetsCalculator')
                      }
                    ]}
                    style={{ paddingBottom: 15 }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FreeToolsView;
